/** Mirrors backend `ScheduledCallOfferEndedReason` (hub `OnScheduledCallOfferEnded` payload). */
export enum ScheduledCallOfferEndedReason {
  Started = 1,
  Ended = 2,
}
